import React, { Component } from 'react';

import './EstrategiaRelacionamentos.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import CountUp, {startAnimation} from 'react-countup';
import Swipeable from 'react-swipeable';
import $ from 'jquery';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	estrategia_content
} from '../../settings';

import {
	TabButton,
	TabItem,
	HoveredImage
} from '../../components/';

class EstrategiaRelacionamentos extends Component {

	constructor() {
		super();

		this.$ = $;

        this.images = images;
        this.estrategia_content = estrategia_content;

        this.state = {
            width: window.innerWidth,
            cardsDiretores: 0,
            lineDiretoresLeft: 0,
            tabsActive: null
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeTabs = this.changeTabs.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeTabs(i) {
    	const { tabsActive } = this.state;
    	console.log(i);
    	
    	this.setState({
    		tabsActive: (tabsActive == i) ? null : i
    	});

    	let target = $('.accordion__item:nth-child('+ (i + 1) +')');
		setTimeout(function() {
			this.$("html, body").stop().animate({ scrollTop: target.offset().top }, 500, 'swing');
		}.bind(this), 100);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('6.4 Relacionamentos');
    }

	render() {
        const { width, tabsActive } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'relacionamentos'
		];

		const accordionItemClass0 = ['accordion__item', 'test-classname'];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>6.4 Relacionamentos - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>6.4</span> Relacionamentos</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Estratégia</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
			        			
				        		<div className="column column--half">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				Interagimos com os mais diversos grupos da sociedade, firmando e consolidando parcerias que contribuam, de alguma forma, para desenvolver os mercados financeiros e de capitais.
										</p>
					        			<p className="gri_p">
					        				<span className="gri_label"><text>GRI 102-42</text></span>
										</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--no-padding-mobile text-center">
				        			<Fade bottom>
					        			<HoveredImage
					        				image1={ this.images.relacionamentos_img1 }
					        				image2={ this.images.relacionamentos_img1_hover } />
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content interacoes__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="blue_title">Veja a seguir as principais interações no ano,<br />divididas por categorias:</h2>
				        			</Fade>
				        		</div>
		        			</div>
		        		</div>

		        		<div className="views__content interacoes__view__content row">
			        		<div className="container">
				        		<div className="column">

				        			<Accordion>
								        <AccordionItem className={ (tabsActive == 0 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>

								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 0)}>Parceiros</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel draggable={false} showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1"> 
										            <div>
										            	<div className="centered_image"><img src={ this.images.relacionamentos_b3 } /></div>
										            	<p>Participação nas câmaras consultivas de Novo Mercado, de Listagem da Bolsa, do Mercado Imobiliário e de Estatais, além do Cise, órgão máximo de governança do ISE (Índice de Sustentabilidade Empresarial), e do Grupo de Trabalho de Renda Fixa. Representantes da B3 atuam em nossos fóruns para fomentar o debate e sugerir ajustes operacionais. Diversas ações foram desenvolvidas em conjunto em 2018; entre elas, o Congresso Brasileiro de Mercado de Capitais e a Agenda ANBIMA B3 de Mercado de Capitais, com uma série de iniciativas para promover o desenvolvimento do mercado.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_ABVCAP } /></div>
										            	<p>A parceria com a entidade consiste no Código de FIP/FIEE (Fundo de Investimento em Participações/Fundo de Investimento em Empresas Emergentes), que estabelece as melhores práticas para esse mercado. Em 2018, foram iniciadas discussões de reformulação do código, a fim de adequá-lo aos avanços da indústria e incorporar as mudanças das Instruções CVM 578 e 579, que tratam do funcionamento dos FIPs e das regras contábeis.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_ABRAPP } /></div>
										            	<p>Participação no Conselho de Autorregulação da Associação Brasileira das Entidades Fechadas de Previdência Complementar. A parceria visa estreitar a troca de informações e elaboração de projetos de aprimoramento da regulação aos investidores.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_Ancord } /></div>
										            	<p>Constante troca de informações pela área de Supervisão da Ancord (Associação Nacional das Corretoras e Distribuidoras de Títulos e Valores Mobiliários, Câmbio e Mercadorias). Participamos do Comitê Gestor do Bacenjud, sistema eletrônico do BC que permite ao juiz solicitar informações sobre movimentação bancária de clientes das instituições financeiras e determinar o bloqueio de contas. Como membros do Comitê, discutimos o regulamento Bacenjud 2.0 e a atualização dos códigos de respostas usados pelas instituições financeiras.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_CFA } /></div>
										            	<p>Manutenção de convênio na área da Educação com a CFA Society Brazil. Em setembro, foi lançada uma prova específica da CGA para os profissionais com a CFA.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_CNSEG } /></div>
										            	<p>Participação nas reuniões da Comissão de Investimentos da confederação. Em 2018, atuamos na elaboração de proposta para equiparar as regras das entidades previdenciárias para gestores de recursos à Instrução CVM 558.</p>
									            	</div>
										            <div>
										            	<div className="centered_image"><img src={ this.images.parceiros_fenaprevi } /></div>
										            	<p>Participação na Comissão de Investimento da Federação Nacional de Previdência Privada e Vida e dos grupos de trabalho que discutem propostas para aprimoramento da Resolução CMN 4.444 e os demais temas regulatórios da agenda conjunta.</p>
									            	</div>
												</Carousel>

								            </AccordionItemBody>
								        </AccordionItem>


								        <AccordionItem className={ (tabsActive == 1 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 1)}>Imprensa</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>A interação com a imprensa acontece frequentemente. Em 2018, esse trabalho obteve os seguintes resultados:</p>

					        					<div className="highlight_numbers row">
													<div className="highlight_numbers__number">
														<h4 className="first_text">
										                	<CountUp delay={0} end={ 200 } />
										                </h4>
														<h5 className="second_text">solicitações<br />de dados</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">
										                	<CountUp delay={0} end={ 178 } />
										                </h4>
														<h5 className="second_text">pedidos<br />de entrevista</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">
										                	<CountUp delay={0} end={ 12 } />
										                </h4>
														<h5 className="second_text">conferências<br />para divulgação<br />de resultados</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">
										                	<CountUp delay={0} end={ 136 } />
										                </h4>
														<h5 className="second_text">press releases<br />enviados</h5>
													</div>
												</div>

								            	<h4>Pesquisa Raio X do investidor brasileiro</h4>
								            	<p>Tema de reportagens de TV, jornais e publicações online, a pesquisa inseriu a ANBIMA como porta-voz no debate sobre educação financeira.</p>

								            	<h4>Agenda ANBIMA e B3 de Mercado de Capitais: caminho para o desenvolvimento</h4>
								            	<p>O potencial que o mercado de capitais tem para acelerar o desenvolvimento econômico e social do Brasil pautou nossas interações com a imprensa ao longo ano. O assunto ganhou a manchete do jornal Valor Econômico, na data da abertura do Congresso Brasileiro de Mercado de Capitais em São Paulo.</p>

								            </AccordionItemBody>
								        </AccordionItem>


								        <AccordionItem className={ (tabsActive == 2 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 2)}>Governo/reguladores e autorreguladores</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery2"> 

										            <div>
										            	<div className="centered_image"><img height="120" src={ this.images.relacionamentos_cvm } /></div>
										            	<p>Participação no Comitê Consultivo de Educação, nos grupos de trabalhos sobre finanças e produtos imobiliários e dos fóruns Títulos Verdes e Finanças Verdes do LAB (Laboratório de Inovação Financeira). Em 2018, foi assinado o terceiro convênio com a autarquia, dessa vez para habilitação de administradores de carteiras de valores mobiliários e supervisão de precificação de ativos e de distribuição de cotas de fundos. Os dois convênios já existentes foram ampliados: o para análise prévia de ofertas públicas de ações, debêntures e cotas de fundos imobiliários foi expandido para cotas de FIPs (Fundos de Investimento em Participações), FIDCs (Fundos de Investimento em Direitos Creditórios) e outros lastros de CRIs (Certificados de Recebíveis Imobiliários); e o convênio para aplicação de penalidades e celebração de termos de compromisso foi otimizado em relação à aprovação de materiais publicitários.</p>
										            	<h3>NEC (Núcleo de Estudos Comportamentais)</h3>
										            	<p>Participação em comitê formado por especialistas em ciências sociais e comportamentais convidados pela CVM para oferecer reflexões, sugestões, recomendações e subsídios técnicos que contribuam para o aprimoramento das políticas de educação.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_BC } /></div>
										            	<p>Apoio ao BC na operacionalização do Selic há 39 anos e participação no Comitê Consultivo de Câmbio. O estreito relacionamento assegura um canal para sugerir maneiras de fortalecer o SFN (Sistema Financeiro Nacional) e os mercados financeiro e de capitais.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_BNDES } /></div>
										            	<p>Agenda conjunta visa ampliar a participação do mercado de capitais como instrumento do financiamento de longo prazo. Em 2018, foi anunciada uma nova política de participação do banco em fundos de infraestrutura e em fundos de crédito a pequenas e médias empresas. Buscamos discutir a nova política operacional do banco, as propostas relacionadas ao modelo de financiamento conjunto do BNDES com o mercado de capitais e o novo FIDC, lançado com debêntures incentivadas na carteira. Em 2018, também foi renovado o convênio entre ANBIMA e BNDES para troca de informações do mercado.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_MINISTERIO_FAZENDA } /></div>
										            	<p>Foi reativado o Grupo de Trabalho de Mercado de Capitais, do qual fazemos parte. Ao longo do ano, foram trabalhados 15 assuntos, divididos em três macrotemas: desenvolvimento do mercado de seguros e previdência, financiamento à infraestrutura, e desenvolvimento do mercado de dívida.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_RECEITA_FEDERAL } /></div>
										            	<p>Discussões constantes sobre melhorias na tributação do mercado de capitais, como a implementação da Instrução Normativa 1.634, que regula a identificação do beneficiário final.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_tesouro_nacional } /></div>
										            	<p>Alinhamento com as alterações promovidas pelo Tesouro Nacional na nomenclatura dos títulos públicos e debates sobre a regulação do ETF (Exchange Traded Funds) de renda fixa.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_MINISTERIO_PLANEJAMENTO } /></div>
										            	<p>O foco do relacionamento está nas propostas de incentivos para destravar o financiamento de longo prazo, visando maior participação do mercado de capitais.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_MINAS_ENERGIA } /></div>
										            	<p>Apresentação sobre o projeto Renovabio e o ativo CBIO.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_PPI } /></div>
										            	<p>A interação busca discutir a viabilidade de novas propostas para impulsionar o financiamento à infraestrutura.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_previc } /></div>
										            	<p>Reconhecimento pela superintendência como entidade responsável pela certificação dos dirigentes de fundos de pensão. O convênio de cooperação possibilita discussões de agenda em comum e eventos educacionais.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_SUSEP } /></div>
										            	<p>Participação nas reuniões da Comissão de Investimentos da superintendência e manutenção de convênio de troca de informações. Em 2018, os principais temas foram os debates sobre os aprimoramentos nas regras de investimentos das EAPCs e a realização de workshop sobre FIPs, fundos imobiliários e securitização.</p>
									            	</div>

										            <div>
										            	<h3>Conef (Comitê Nacional de Educação Financeira)</h3>
										            	<p>Somos membros do grupo responsável pela direção, supervisão e fomento da Enef (Estratégia Nacional de Educação Financeira). Participamos da Semana Nacional de Educação Financeira com lives sobre investimentos.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_LabInovacao } /></div>
										            	<p>Participação ativa no projeto da CVM para estimular o debate e a criação de ferramentas financeiras que deem suporte ao desenvolvimento sustentável no Brasil. A iniciativa tem o BID (Banco Interamericano de Desenvolvimento) e a ABDE (Associação Brasileira de Desenvolvimento) como parceiros.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.governo_BANCO_MUNDIAL } /></div>
										            	<p>Promoção de iniciativas de financiamento de longo prazo com maior participação do mercado de capitais, por meio da emissão de debêntures uniformes. Em 2018, foi incentivado o ingresso de investidores institucionais na aquisição de títulos de infraestrutura. Também foram tratadas as operações de captação de recursos para serem aplicadas em mecanismos para mitigar falhas de mercado.</p>
									            	</div>

												</Carousel>

											</AccordionItemBody>
								        </AccordionItem>


								        <AccordionItem className={ (tabsActive == 3 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 3)}>Entidades de classe internacionais</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery3"> 
										            <div>
										            	<div className="centered_image"><img src={ this.images.relacionamentos_empea } /></div>
										            	<p>Membro da Associação de Private Equity de Mercados Emergentes.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_FIAFIN } /></div>
										            	<p>Reúne entidades representantes da indústria de fundos. Fomos reeleitos à diretoria da federação por mais dois anos.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_ICMA } /></div>
										            	<p>Afiliados da entidade que atua para o desenvolvimento do mercado de capitais internacional. Participamos da reunião anual da Associação Internacional de Mercado de Capitais em junho, que discutiu novos benchmarks, títulos verdes e digitalização.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_IFIE } /></div>
										            	<p>Atuação na diretoria da entidade e na coordenação do setor das Américas na realização de eventos e na discussão com representantes dos países da região.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_IIFA } /></div>
										            	<p>Reeleição para a diretoria da associação, que discute as particularidades da regulação e autorregulação da indústria de fundos.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_IOSCO } /></div>
										            	<p>Participação nas reuniões da Iosco (Organização Internacional das Comissões de Valores Mobiliários), que está à frente de uma campanha global para conscientizar as pessoas sobre a relevância da educação e da proteção dos investidores.</p>
									            	</div>

										            <div>
										            	<h3>OCDE-Infe (International Survey of Adult Financial Literacy Competencies)</h3>
										            	<p>Somos afiliados ao organismo, que conta com programas e iniciativas voltadas à educação financeira. </p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.internacionais_SMPG } /></div>
										            	<p>Participação ativa no grupo que reúne representantes do mercado de capitais brasileiro.</p>
									            	</div>

												</Carousel>

											</AccordionItemBody>
								        </AccordionItem>


								        <AccordionItem className={ (tabsActive == 4 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 4)}>Entidades de classe nacionais</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery4"> 
										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_FEBRABAN } /></div>
										            	<p>Diálogo sobre temas e eventos da agenda em comum. Participação na Comissão Intrassetorial sobre Sustentabilidade e Meio Ambiente, grupo que busca alinhar o setor financeiro e o mercado de capitais brasileiro em temas socioambientais, e também no GT Blockchain, que discute aspectos técnicos e potenciais usos dessa tecnologia no mercado financeiro.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_ABBC } /></div>
										            	<p>Discussão sobre os desdobramentos da Consulta Pública 57/17 do BC, que aborda a política de segurança cibernética.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_ABBI } /></div>
										            	<p>Debate sobre a Consulta Pública 57/17 do BC, que aborda a política de segurança cibernética.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_Abrasca } /></div>
										            	<p>Apoio ao Prêmio de Melhor Relatório Anual e participação no Conselho de Autorregulação da entidade.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_Apimec } /></div>
										            	<p>Participação no Conselho de Supervisão dos Analistas.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_CCEC } /></div>
										            	<p>Coordenação de grupo composto por outras entidades certificadoras do mercado de capitais para discutir e trocar experiências.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_CODIM } /></div>
										            	<p>Participação do grupo responsável pela elaboração de pronunciamentos e documentos de orientação ao mercado, para facilitar a divulgação de informações das companhias abertas. </p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.nacionais_FPSB } /></div>
										            	<p>Participação do Conselho de Normas de Planejamento Financeiro da Planejar, que reúne as entidades detentoras do direito de conceder a certificação CFP (Certified Financial Planner) no Brasil.</p>
									            	</div>

												</Carousel>

											</AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 5 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 5)}>Entidades das quais fazemos parte</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery5"> 
										            <div>
										            	<div className="centered_image"><img src={ this.images.fazemos_AEF } /></div>
										            	<p>Participação como uma das entidades mantenedoras da associação, que busca dar visibilidade e relevância à educação financeira no Brasil. Em 2018, foram lançados dois cursos a distância para professores e a websérie R$ 100 Neuras, no canal do YouTube Vida e Dinheiro, que aborda assuntos como equilíbrio financeiro, gestão inteligente do dinheiro, poupança e controle de gastos.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.fazemos_CAF } /></div>
										            	<p>Participação no Conselho de Administração e Supervisão da Acaf (Associação dos Apoiadores do CAF), entidade sem fins lucrativos que presta apoio técnico e administrativo ao CAF.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.fazemos_CNF } /></div>
										            	<p>Integrantes da diretoria, colaboramos com as propostas apresentadas pelos poderes Legislativo e Executivo com o envio de subsídios técnicos que contribuem para a atuação da confederação no desenvolvimento dos mercados financeiro e de capitais.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.fazemos_PLANEJAR } /></div>
										            	<p>Associados sênior da Associação Brasileira de Planejadores Financeiros desde 2004, integramos a diretoria da associação, que é a responsável pela certificação CFP. <span className="gri_label"><text>GRI 102-13</text></span></p>
									            	</div>

												</Carousel>

											</AccordionItemBody>
								        </AccordionItem>


								        <AccordionItem className={ (tabsActive == 6 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 6)}>Academia</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

						            			<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery6"> 
										            <div>
										            	<div className="centered_image"><img src={ this.images.academia_CIEE } /></div>
										            	<p>Oferecimento do curso Como Investir em Você para os estudantes do CIEE.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.academia_IepeCdG } /></div>
										            	<h3>Iepe/CdG (Instituto de Estudos de Política Econômica/Casa das Garças)</h3>
										            	<p>Realização do Prêmio ANBIMA de Mercado de Capitais para dissertações de mestrado e teses de doutorado.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.academia_INSPER } /></div>
										            	<p>Adoção da prova da CPA-20 como parte da avaliação dos alunos de matéria optativa dos cursos de graduação de Administração e de Economia.</p>
									            	</div>

										            <div>
										            	<div className="centered_image"><img src={ this.images.academia_NFC } /></div>
										            	<p>Patrocínio do núcleo da FGV (Fundação Getulio Vargas) que desenvolve estudos relativos às finanças comportamentais.</p>
									            	</div>

												</Carousel>

											</AccordionItemBody>
								        </AccordionItem>

								    </Accordion>

				        		</div>
		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { EstrategiaRelacionamentos };
